// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _TvSlTpCache {
    constructor() {
        this.slTpIdsMap = new Map();
    }
    insertSlTrailingStopPrice(orderId, slPrice, sloffset) {
        const sltpContainer = this.getsltpContainer(orderId);
        const prevSlPrice = sltpContainer.slPrice;
        const prevSlTrOfset = sltpContainer.slTrOfset;
        const prevIsTrailingStop = sltpContainer.isSlTrailingStop;
        sltpContainer.slPrice = slPrice;
        sltpContainer.slTrOfset = sloffset;
        sltpContainer.isSlTrailingStop = true;
        const hasSl = !isNaN(prevSlPrice);
        if (!hasSl) {
            return TvSlTpModificationType.New;
        }
        if (!prevIsTrailingStop) {
            return TvSlTpModificationType.Replace; // replace SL with TrSL
        }
        if (prevSlPrice === slPrice && prevSlTrOfset === sloffset) {
            return TvSlTpModificationType.WithoutChanges;
        }
        return TvSlTpModificationType.ModifyOrder;
    }
    insertSlPrice(orderId, slPrice) {
        const sltpContainer = this.getsltpContainer(orderId);
        const prevSlPrice = sltpContainer.slPrice;
        const prevIsTrailingStop = sltpContainer.isSlTrailingStop;
        sltpContainer.slPrice = slPrice;
        sltpContainer.slTrOfset = NaN;
        sltpContainer.isSlTrailingStop = false;
        const hasSl = !isNaN(prevSlPrice);
        if (!hasSl) {
            return TvSlTpModificationType.New;
        }
        if (prevIsTrailingStop) {
            return TvSlTpModificationType.Replace; // replace TrSL with SL
        }
        if (prevSlPrice === slPrice) {
            return TvSlTpModificationType.WithoutChanges;
        }
        return TvSlTpModificationType.ModifyOrder;
    }
    insertTpPrice(orderId, tpPrice) {
        const sltpContainer = this.getsltpContainer(orderId);
        const prevTpPrice = sltpContainer.tpPrice;
        sltpContainer.tpPrice = tpPrice;
        const hasTp = !isNaN(prevTpPrice);
        if (!hasTp) {
            return TvSlTpModificationType.New;
        }
        if (prevTpPrice === tpPrice) {
            return TvSlTpModificationType.WithoutChanges;
        }
        return TvSlTpModificationType.ModifyOrder;
    }
    getSlTrailingStopPrices(orderId) {
        const sltpContainer = this.getsltpContainer(orderId);
        return [sltpContainer.slPrice, sltpContainer.slTrOfset];
    }
    getSlPrice(orderId) {
        const sltpContainer = this.getsltpContainer(orderId);
        return sltpContainer.slPrice;
    }
    getTpPrice(orderId) {
        const sltpContainer = this.getsltpContainer(orderId);
        return sltpContainer.tpPrice;
    }
    getSlId(orderId, isTrailingStop) {
        const sltpContainer = this.getsltpContainer(orderId);
        if (isTrailingStop) {
            const sltrStopIndex = sltpContainer.slTrIndex;
            return `${orderId}-TrSL(${sltrStopIndex})`;
        }
        else {
            const slIndex = sltpContainer.slIndex;
            return `${orderId}-SL(${slIndex})`;
        }
    }
    getTpId(orderId) {
        const sltpContainer = this.getsltpContainer(orderId);
        const tpIndex = sltpContainer.tpIndex;
        return `${orderId}-TP(${tpIndex})`;
    }
    isSlId(orderId) {
        return orderId.includes('-SL(') || orderId.includes('-TrSL(');
    }
    isTpId(orderId) {
        return orderId.includes('-TP(');
    }
    removeSlSuffix(orderId) {
        return orderId.replace(/-SL\(\d+\)/, '').replace(/-TrSL\(\d+\)/, '');
    }
    removeTpSuffix(orderId) {
        return orderId.replace(/-TP\(\d+\)/, '');
        // const parentOrderId = orderId.replace('-TP', '');
        // this.getsltpContainer(parentOrderId).updateTpIndex();
        // return parentOrderId;
    }
    removeSl(slOrderId) {
        const orderId = this.removeSlSuffix(slOrderId);
        const sltpContainer = this.getsltpContainer(orderId);
        sltpContainer.clearSl();
    }
    removeTp(tpOrderId) {
        const orderId = this.removeTpSuffix(tpOrderId);
        const sltpContainer = this.getsltpContainer(orderId);
        sltpContainer.clearTp();
    }
    hasSlPrice(orderId) {
        const sltpContainer = this.getsltpContainer(orderId);
        return !isNaN(sltpContainer.slPrice);
    }
    hasTpPrice(orderId) {
        const sltpContainer = this.getsltpContainer(orderId);
        return !isNaN(sltpContainer.tpPrice);
    }
    getsltpContainer(orderId) {
        if (this.slTpIdsMap.has(orderId)) {
            return this.slTpIdsMap.get(orderId);
        }
        const sltpContainer = new SlTPIndexContainer();
        this.slTpIdsMap.set(orderId, sltpContainer);
        return sltpContainer;
    }
}
class SlTPIndexContainer {
    constructor() {
        this.slIndex = 1;
        this.slPrice = NaN;
        this.tpIndex = 1;
        this.tpPrice = NaN;
        this.slTrIndex = 1;
        this.slTrOfset = NaN;
        this.isSlTrailingStop = false;
    }
    clearTp() {
        this.tpIndex += 1;
        this.tpPrice = NaN;
    }
    clearSl() {
        this.slIndex += 1;
        this.slPrice = NaN;
        this.slTrOfset = NaN;
        this.isSlTrailingStop = false;
    }
}
export var TvSlTpModificationType;
(function (TvSlTpModificationType) {
    TvSlTpModificationType[TvSlTpModificationType["WithoutChanges"] = 0] = "WithoutChanges";
    TvSlTpModificationType[TvSlTpModificationType["New"] = 1] = "New";
    TvSlTpModificationType[TvSlTpModificationType["ModifyOrder"] = 2] = "ModifyOrder";
    TvSlTpModificationType[TvSlTpModificationType["Replace"] = 3] = "Replace";
})(TvSlTpModificationType || (TvSlTpModificationType = {}));
export const TvSlTpCache = new _TvSlTpCache();
